import axios from "axios";
import { confirmationPages, endpoints } from "./config";

export async function callServer({
    body,
    endpoint = endpoints.nextStep,
    method = "POST", // Add default method
    headers = {}, // Add optional headers
}) {
    try {
        const response = await axios({
            url: endpoint,
            method: method, // Use the passed method instead of hardcoded "POST"
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                ...headers, // Merge additional headers
            },
            data: body || null,
        });

        if (response.data.WebAPIResultText && !response.data.WebAPISuccess) {
            console.log("API message:", response.data.WebAPIResultText);
        }

        return response.data;
    } catch (error) {
        // ... error handling remains the same
        throw error;
    }
}

export function redirectPost(postUrl, data) {
    const form = document.createElement("form");
    document.body.appendChild(form);
    form.method = "post";
    form.action = postUrl;
    for (const field of Object.keys(data)) {
        const input = document.createElement("input");
        input.type = "hidden";
        input.name = field;
        input.value = data[field];
        form.appendChild(input);
    }
    form.submit();
}

export function redirectGet(error = false, getUrl = "") {
    let page;

    // Hvis getUrl er en absolut URL (starter med http:// eller https://), brug den direkte
    if (getUrl && getUrl.startsWith("http")) {
        page = getUrl;
    } else {
        // Hvis getUrl er tom, brug success eller error
        page = getUrl
            ? getUrl
            : error
              ? confirmationPages.error
              : confirmationPages.success;
    }

    // Hvis page allerede er en absolut URL, omdiriger direkte til den
    if (page.startsWith("http")) {
        window.location = page;
    } else {
        // Hvis det er en relativ URL, sammensæt den med den nuværende base URL
        const maybeSlash =
            window.location.pathname[window.location.pathname.length - 1] !==
            "/"
                ? "/"
                : "";
        window.location =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname +
            maybeSlash +
            page;
    }
}

export async function getMosData() {
    let mosResponse;
    mosResponse = await callServer({
        endpoint: endpoints.getMosData,
    });

    if (mosResponse.WebAPISuccess === true) {
        return mosResponse.MosContactInformation;
    }
    return null;
}

export async function handleSubmitAndPayment(
    dto,
    formValues,
    allFlowSteps,
    flowSteps
) {
    let paymentResponse;
    let submitResponse;
    let response;
    const startPayment = formValues.PayFirstRateNow === true ? true : false;

    var endpoint = endpoints.handlePaymentAndSubmitToMos + "/" + startPayment;
    response = await callServer({
        body: { indmeldelseDTO: dto, allFlowSteps, flowSteps },
        endpoint: endpoint,
    });

    paymentResponse = response.PaymentResult;
    submitResponse = response.SubmitRegistrationResult;

    //Redirects
    if (submitResponse === true && paymentResponse?.WebAPISuccess === true) {
        if (
            paymentResponse?.HttpMethod === "GET" &&
            paymentResponse?.RedirectUrl
        ) {
            window.location.href = paymentResponse.RedirectUrl;
        } else if (
            paymentResponse?.HttpMethod === "POST" &&
            paymentResponse?.RedirectUrl
        ) {
            redirectPost(
                paymentResponse.RedirectUrl,
                paymentResponse.HttpParameters
            );
        } else {
            redirectGet(false);
        }
    } else {
        redirectGet(true);
    }

    return {
        Success: paymentResponse?.WebAPISuccess,
        SubmitResponse: submitResponse,
    };
}
